import {Container} from '@orbit-ui/components/container';
import {FormSection} from '@orbit-ui/components/form-section';
import {PageHeader} from '@orbit-ui/components/page-header';
import {PageContent} from '@/components/page-content';
import {PageWrapper} from '@/components/page-wrapper';
import {ThemeSettingsForm} from '../user/components/theme-settings-form';

function UserSettingsView() {
  return (
    <>
      <PageWrapper>
        <PageContent>
          <Container>
            <PageHeader title="User Settings" />
            <FormSection title="Appearance" description="Adjust the appearance of the application.">
              <ThemeSettingsForm className="col-span-6" />
            </FormSection>
          </Container>
        </PageContent>
      </PageWrapper>
    </>
  );
}

export {UserSettingsView};
